import PropTypes from "prop-types";
import { Box, Card, CardContent, Typography } from "@mui/material";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TimerIcon from '@mui/icons-material/Timer';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

const StatItem = ({ icon: Icon, label, value, iconGradient, rowGradient }) => (
    <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 1.5,
        borderRadius: "12px",
        background: rowGradient,
        mb: 1.5,
        border: "1px solid rgba(0,0,0,0.04)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    }}>
        <Box sx={{
            width: 46,
            height: 46,
            borderRadius: "12px",
            background: iconGradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}>
            <Icon sx={{ color: "white", fontSize: 22 }} />
        </Box>
        <Box>
            <Typography variant="caption" sx={{
                color: "#6b7a99",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.6px",
                fontSize: "0.65rem",
                display: "block",
            }}>
                {label}
            </Typography>
            <Typography variant="h5" sx={{
                fontWeight: 800,
                color: "#1A3865",
                lineHeight: 1.2,
            }}>
                {value}
            </Typography>
        </Box>
    </Box>
);

const EstatisticaGeral = ({ horasDisp, horasProd, qtdColab }) => {
    return (
        <Box sx={{ position: "relative", height: "100%" }}>
            <Card sx={{
                width: "100%",
                height: "100%",
                background: "linear-gradient(145deg, #f8faff 0%, #eef2ff 60%, #e8eeff 100%)",
                boxShadow: "0 8px 32px rgba(26, 56, 101, 0.18), 0 2px 8px rgba(100, 125, 238, 0.1)",
                borderRadius: "16px",
                border: "1px solid rgba(100, 125, 238, 0.2)",
                overflow: "hidden",
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #647DEE, #1A3865, #269FFB)",
                },
            }}>
                <CardContent sx={{ pt: 3 }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 700,
                        color: "#1A3865",
                        letterSpacing: "0.5px",
                        mb: 2,
                        textAlign: "center",
                    }}>
                        Estatísticas do Período
                    </Typography>

                    <StatItem
                        icon={ManageAccountsIcon}
                        label="Colaboradores Envolvidos"
                        value={qtdColab}
                        iconGradient="linear-gradient(135deg, #647DEE, #8FA4F5)"
                        rowGradient="linear-gradient(135deg, rgba(100,125,238,0.1), rgba(100,125,238,0.04))"
                    />
                    <StatItem
                        icon={TimerIcon}
                        label="Horas Disponíveis"
                        value={`${horasDisp}h`}
                        iconGradient="linear-gradient(135deg, #1A3865, #2D5AA0)"
                        rowGradient="linear-gradient(135deg, rgba(26,56,101,0.1), rgba(26,56,101,0.04))"
                    />
                    <StatItem
                        icon={PrecisionManufacturingIcon}
                        label="Horas Produtivas"
                        value={`${horasProd}h`}
                        iconGradient="linear-gradient(135deg, #CA6111, #E07B2A)"
                        rowGradient="linear-gradient(135deg, rgba(202,97,17,0.1), rgba(202,97,17,0.04))"
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

StatItem.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  iconGradient: PropTypes.string.isRequired,
  rowGradient: PropTypes.string.isRequired,
};

EstatisticaGeral.propTypes = {
  horasDisp: PropTypes.number,
  horasProd: PropTypes.number,
  qtdColab: PropTypes.number,
};

export default EstatisticaGeral;
